"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[369],{

/***/ 50369:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* reexport */ StkBlockCallToAction; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/html-react-parser/index.mjs
var html_react_parser = __webpack_require__(25935);
// EXTERNAL MODULE: ./components/molecules/Blocks/index.js + 2 modules
var Blocks = __webpack_require__(6666);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
;// CONCATENATED MODULE: ./components/blocks/stackable/BlockCallToAction/StkBlockCallToAction.js




/**
 * Stackable Call To Action
 *
 * A .
 *
 * @author RKC
 * @param  {object}  props                 The component properties.
 * @param  {object}  props.innerBlocks     The array of inner blocks to display.
 * @param  {string}  props.originalContent Original prerendered content.
 * @return {Element}                       The Feature component.
 */ function StkBlockCallToAction(param1) {
    var innerBlocks = param1.innerBlocks, originalContent = param1.originalContent;
    // Get Wordpress source media URL to be replaced registered in env.
    // let sourceURL = process.env.NEXT_WORDPRESS_SOURCE_MEDIA_URL
    // Get S3 Wordpress media URL to replace with registered in env.
    // let s3URL = process.env.NEXT_WORDPRESS_S3_MEDIA_URL
    var options = {
        replace: function(param) {
            var attribs = param.attribs, children = param.children;
            if (!attribs) {
                return;
            }
            // Replace the source Wordpress media URL with S3 URL
            if (children && children.length) {
                children.forEach(function(element) {
                    if (element.type === 'text') {
                        // element.data = element.data.replace(sourceURL, s3URL)
                        element.data = element.data.replace('https://sharqinsurance.web2box.com/wp-content', 'https://s3.eu-west-1.amazonaws.com/web2box.com');
                        return element;
                    }
                });
            }
            var classes = attribs.class;
            if (classes && classes.includes('stk-inner-blocks')) {
                return(/*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: classes,
                        children: !!(innerBlocks === null || innerBlocks === void 0 ? void 0 : innerBlocks.length) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Blocks/* default */.Z, {
                            blocks: innerBlocks
                        })
                    })
                }));
            }
        }
    };
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: (0,html_react_parser/* default */.ZP)(originalContent, options)
    }));
};
StkBlockCallToAction.propTypes = {
    innerBlocks: prop_types_default().arrayOf(prop_types_default().shape({
        block: (prop_types_default()).object,
        index: (prop_types_default()).number
    })),
    originalContent: (prop_types_default()).string
};

;// CONCATENATED MODULE: ./components/blocks/stackable/BlockCallToAction/index.js



/***/ })

}]);